import { TextField } from "@mui/material";
import Disabled from "components/common/Disabled";
import { useDispatch, useSelector } from "react-redux";
import * as programActions from "store/actions/input/program/programActions";
import { selectSurplusLinesTaxReporting } from "store/selectors/input/program/programSelectors";

const NjTransactionNumber = () => {
  const dispatch = useDispatch();
  const reporting = useSelector(selectSurplusLinesTaxReporting);

  return (
    <Disabled ifReadOnly>
      <TextField
        label={"NJ Transaction Number"}
        value={reporting?.njTransactionNumber ?? ""}
        onChange={(event) =>
          dispatch(
            programActions.updateSurplusLinesTaxReporting(
              "njTransactionNumber",
              event.target.value
            )
          )
        }
        variant={"filled"}
        size={"small"}
        fullWidth
      />
    </Disabled>
  );
};

export default NjTransactionNumber;
